
// This is called to comma-fy any number
export default function numberWithCommas(x:number):any {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}